import { render, staticRenderFns } from "./CreateAlbaranSAP.vue?vue&type=template&id=207b2e14"
import script from "./CreateAlbaranSAP.vue?vue&type=script&lang=js"
export * from "./CreateAlbaranSAP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports